import {Button, Dialog, DialogFooter} from '@startlibs/components'
import {Errors, Field, TextInput, useProvideErrors, WithForm} from '@startlibs/form'
import React, { useRef, useState } from 'react'
import {getJwt} from '../../hooks/useJwt'
import {jwtPostFetcher} from '../../utils/authFetch'
import { useToggle } from '@startlibs/core'
import { StarRating } from '../../components/StarRating'
import { setNotification } from '../../components/Notifications'
import {FormattedMessage, useIntl} from "react-intl";

export const FeedbackDialog = ({feedbackPopup, requestId = 0}) => {

  const loadingFeedback = useToggle(false)
  const formRef = useRef()
  const intl = useIntl()
  const [formValues] = useState({review: ""})
  const [ErrorProvider, errors, {setError}] = useProvideErrors()
  const [rating, setRating] = useState(0);
  const [selection, setSelection] = useState(0);
  
  const saveRating = (value) => {
    if(value < 1 || value > 5){
      return
    }
    jwtPostFetcher(getJwt())('/api/' + ( requestId > 0 ? 'expert/feedback?requestId='+requestId+'&presave=true' : 'feedback?presave=true'),{stars: value, message: ""},{method:"PUT"})
      .then((_response) => {})
    setRating(value)
  }

  return <Dialog 
    title={intl.formatMessage({defaultMessage:"Give feedback",description:"Feedback dialog title"})}
    closeDialog={feedbackPopup.close}
    >
    <WithForm
      values={formValues}
      ref={formRef}
      action={(_values)=> {}}
      onSuccess={(e) => {
        if(!rating){
          return setError("Error", intl.formatMessage({
            defaultMessage: 'Please rate your experience from 1 to 5 stars.',
            description: 'Feedback dialog required rating error message'
          }))
        }
        loadingFeedback.open();
        jwtPostFetcher(getJwt())('/api/' + ( requestId > 0 ? 'expert/feedback?requestId='+requestId : 'feedback'),{stars: rating, message: e.review},{method:"PUT"})
          .then((_response) => {
            setNotification({type:"success", timeout: 4000, msg: intl.formatMessage({
                defaultMessage:'Thank you for your feedback!',
                description: 'Feedback dialog success message'
            })})
            loadingFeedback.close();
            feedbackPopup.close();
          })
          .catch((_error) => {
            setError("Error", intl.formatMessage({
              defaultMessage: 'It was not possible to send your feedback. Please try again.',
              description: 'Feedback dialog submit error message'
            }))
            loadingFeedback.close();
          })
        
      }}
    >
      {_form => <>
        <p css="font-size: 14px !important;"><FormattedMessage
          defaultMessage="Your feedback is invaluable to us as we work to improve this platform."
          description="Feedback dialog description"
        /></p>
        <Field label={intl.formatMessage({
            defaultMessage: "How would you rate your experience?",
            description: "Feedback dialog rating input label"
          })}>
          <StarRating value={0} size={60} quantity={5} rating={rating} setRating={saveRating} selection={selection} setSelection={setSelection} />
        </Field>
        <TextInput
          label={intl.formatMessage({
            defaultMessage: "Give more details",
            description: "Feedback dialog review input label"
          })}
          path="review"
          values={null}
          textarea
          autoResize
          placeholder={intl.formatMessage({
            defaultMessage: "Please include as much information as you would like",
            description: "Feedback dialog review input placeholder"
          })}
        />
        <ErrorProvider value={errors}>
          <Errors/>
        </ErrorProvider>
        <DialogFooter>
          <Button onClick={feedbackPopup.close}><FormattedMessage
            defaultMessage="Maybe later"
            description="Maybe later button"
          /></Button>
          <Button highlight isLoading={loadingFeedback.isOpen} type="submit"><FormattedMessage
            defaultMessage="Submit feedback"
            description="Submit feedback button"
          /></Button>
        </DialogFooter>
      </>
    }</WithForm>
  </Dialog> 
}
